<template>
  <div class="cart-section" :class="{ 'mcart': this.tickets === null || this.tickets.length == 0 }">
      <h2 class="text-xl font-bold mb-4">{{$t('cart')}}</h2>
        <div style="width:100%;padding-bottom: 10px; text-align: center;" v-if="this.tickets === null || this.tickets.length == 0">{{$t('no_tickets')}}</div>
        <div class="cart" v-else>
          <div class="cartdetails" v-for="instance in this.tickets" :key="instance.id">
          <div class="mb-4" style="font-weight: 600;">
            <div style="font-size:16px;">{{instance.name}}</div>
            <div v-if="instance.dateVisibility == null || instance.dateVisibility == 0" style="font-size:14px;">{{formatEiDateFull(instance)}}</div>
            <div v-if="instance.dateVisibility == 1" style="font-size:14px;">{{formatEiDate(instance)}}</div>
          </div>
            <div v-for="(ticket,index) in instance.tickets" :key="index">
                <div style="padding-bottom:5px; margin-bottom:10px;border-bottom: 1px solid #888888;" v-if="ticket.promotion !== null">
                  {{ticket.quantity}} {{$t('ticket')}} x {{ ticket.price }} RON ({{ ticket.name }})
                </div>
            </div>
          </div>
          <div style="display: flex;align-items: center;">Total: {{ total }} RON</div>
          <div style="text-align:center">
              <router-link to="/checkout">
                <button class="btnCart md:mt-3 bg-primary-muzeu text-white font-bold px-2 py-1">
                  <div class="flex align-center">
                      <span class="mr-1">{{$t('checkout')}}</span>
                  </div>
                </button>
              </router-link>
          </div>
        </div>
      </div>
  </template>
  
  <script>

import {formatDate} from '../mixins/dateformats'
import {formatDay} from '../mixins/dateformats'
import {formatHour} from '../mixins/dateformats'
import {formatYear} from '../mixins/dateformats'
import {formatEiDateFull, formatEiDate} from '../mixins/dateformats'

export default {
  name: 'Cart',
  props: {
    tickets: {
      required: true
    },
  },
  computed: {
    total() {
      if (this.tickets == null){
        return 0;
      }
      let q = 0;
      this.tickets.forEach(ei => {
        ei.tickets.forEach(ticket => {
          q += ticket.price * ticket.quantity;
        });
      });
      return Math.round(q * 100) / 100;
    }
  },
  methods: {
    formatDate,
    formatDay,
    formatHour,
    formatYear,
    formatEiDateFull,
    formatEiDate
  },
  async created() {
  }
}
</script>